import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureGeneral } from "../../../hooks/Capture";
import { FlowTestsInputDataForm } from "../../../types/forms/flowTest";
import CaptureFlowTest from "../../FlowTest/CaptureFlowTests";

interface FlowTestTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const FlowTestTab: React.FC<FlowTestTabProps> = ({ captureId, handleError, canEdit }) => {
  const { constructionDetailsData, isPending, upsertConstructionDetails } = useCaptureGeneral(captureId);

  if (isPending && !constructionDetailsData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  const handleCaptureFlowTestUpsert = async (values: FlowTestsInputDataForm) => {
    try {
      await upsertConstructionDetails({
        ...constructionDetailsData,
        ...values.constructionDetails,
      });
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <CaptureFlowTest
      captureId={Number(captureId)}
      constructionDetails={constructionDetailsData}
      canEdit={canEdit}
      onSubmit={handleCaptureFlowTestUpsert}
    />
  );
};

export default FlowTestTab;
